import { Col, Form, Row, Typography } from "antd";
import StatusList from "./StatusList";
import StatusImage from "./StatusImage";
import { useEffect, useState } from "react";
import { MazakaButton } from "apps/Common/MazakaButton";
import useMazakaForm from "hooks/useMazakaForm";
import { MazakaForm } from "apps/Common/MazakaForm";
import { useSearchParams } from "react-router-dom";
import { useGetAdvertDetails } from "apps/RealState/Details/ServerSideStates";
import StatusVehicleBody from "./StatusVehicleBody";
import { useDispatch } from "react-redux";
import { handleSetDoneSteps } from "../../ClientSideStates";
import { updateFaultyPieceAttr } from "../../Services";
import GeneralLoadingSpinner from "apps/Common/GeneralLoadingSpinner";
import CustomNoData from "apps/Common/CustomNoData";
import { Helmet } from "react-helmet-async";

const BodyReportIndex = (props: any) => {
  const { Text } = Typography;
  const [form] = Form.useForm();
  const { formActions, mazakaForm } = useMazakaForm(form);
  const [isValid, setIsValid] = useState(false);
  const [searchParams,setSearchParams] = useSearchParams();
  const advertId = searchParams.get("id");
  const dispatch = useDispatch();
  useEffect(() => {
    setSearchParams(prev => {
      const newParams = new URLSearchParams(prev);
      newParams.set("currentStep", "2"); 
      return newParams;
    });
  }, []);
  const [data, setData] = useState([
    {
      key: "front-bumper",
      parca: "Ön Tampon",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "engine-hood",
      parca: "Motor Kaputu",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "ceiling",
      parca: "Tavan",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "right-front-fender",
      parca: "Sağ Ön Çamurluk",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "right-front-door",
      parca: "Sağ Ön Kapı",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "right-rear-door",
      parca: "Sağ Arka Kapı",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "right-rear-fender",
      parca: "Sağ Arka Çamurluk",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "left-front-fender",
      parca: "Sol Ön Çamurluk",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "left-front-door",
      parca: "Sol Ön Kapı",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "left-rear-door",
      parca: "Sol Arka Kapı",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "left-rear-fender",
      parca: "Sol Arka Çamurluk",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "trunk-lid",
      parca: "Bagaj Kapağı",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
    {
      key: "rear-bumper",
      parca: "Arka Tampon",
      status: {
        orginal: true,
        localPainted: false,
        painted: false,
        changed: false,
      },
    },
  ]);
  const advertDetails = useGetAdvertDetails(advertId);
  function formatData(items: any[]) {
    let formattedList = [];
    for (let item of items) {
      let obj = {
        advertId: advertId,
        pieceKey: item.key,
        pieceName: item.parca,
        pieceOriginalStatus: item.status.orginal,
        pieceLocalPaintedStatus: item.status.localPainted,
        piecePaintedStatus: item.status.painted,
        pieceChancedStatus: item.status.changed,
        pieceStatusValue: item.status?.descValue || null,
        pieceStatusTitle: item.status?.descTitle || null,
      };
      formattedList.push(obj);
    }
    return formattedList;
  }
  const reverseFormat = (pieces: any[]) => {
    return pieces.map((item) => ({
      key: item.pieceKey,
      parca: item.pieceName,
      status: {
        orginal: item.pieceOriginalStatus,
        localPainted: item.pieceLocalPaintedStatus,
        painted: item.piecePaintedStatus,
        changed: item.pieceChancedStatus, 
        descValue: item.pieceStatusValue,
        descTitle: item.pieceStatusTitle,
      },
    }));
  };

  useEffect(() => {
    if (advertDetails.data?.data) {
      const details = advertDetails.data?.data;
      const dbBodyReport = details?.advertFaultyPieceAttr;
      setIsValid(true);
      if (dbBodyReport?.length > 0) {
       
        setData(reverseFormat(dbBodyReport));
    
      }
    }
  }, [advertDetails.data?.data]);

  useEffect(() => {
  const categoryKey = advertDetails.data?.data?.categoryCombinedKey;
  if (categoryKey) {
    const parts = categoryKey.split("_") || [];
    if (parts.length > 1 && parts[1] !== "5278" && parts[1] !== "2") {
      props.setCurrentStep(3);
    }
  }
}, [advertDetails.data?.data?.categoryCombinedKey]);



  const handleOnFinish = async (type?:string) => {
    
    mazakaForm.setLoading();

    try {
      let requestData = formatData(data)
      const response = await updateFaultyPieceAttr(requestData);
      mazakaForm.setSuccess(2000, () => response?.message || "İşlem Başarılı");
      advertDetails.refetch()
      setIsValid(true);
      if(type==="saved&continue")
      {
        props.setCurrentStep(3);
                        dispatch(
                          handleSetDoneSteps({
                            data: advertId
                              ? [0, 1, 2, 3, 4, 5, 6, 7]
                              : [0, 1, 2],
                          })
                        );
      }

    } catch (error: any) {
      mazakaForm.setFailed(2000, error?.message);
      console.log("somethings wrong during saved bodyReport", error);
    }
  };

  console.log("parca",data)

  return (
    <>
    {
      advertDetails.isLoading ||advertDetails.isFetching?<>
      <GeneralLoadingSpinner/>
      </>:<>
      
      {props.readOnlyMode ? (
        <>
       
          <Row>
            
            <Col xs={24}>
            <Helmet>
          <title className="capitalize">{"Gövde Raporu"}</title>
        </Helmet>
              <Text className="!text-black !text-2xl !font-bold">
                Boyalı veya Değişen Parça
              </Text>
            </Col>
            <Col xs={24} lg={10} className="!flex items-center">
              <StatusImage
                data={data}
                setData={setData}
                readOnlyMode={props.readOnlyMode}
              />
            </Col>
            <Col xs={24} lg={12}>
            <StatusVehicleBody data={data} />
            {/* {
              data.filter(
                (item: any) =>
                  item?.status.localPainted ||
                  item?.status.painted ||
                  item?.status.changed
              )?.length>0?<>
              
              <StatusVehicleBody data={data} />
              </>:<>
              {data.map((item, index) => (
              <div key={item.key}>
                <h3>{item.parca}</h3>
              </div>
            ))}
              {console.log("DATAAAA",data)}
           
             
              <CustomNoData description="Araba parçasının durumu belirlenmemiş" />
              </>
            } */}
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Col xs={24} className="mt-12">
            <MazakaForm
              submitButtonVisible={false}
              form={form}
              onFinish={handleOnFinish}
            >
              <Row gutter={[0, 20]}>
                <Col xs={24} className="!flex justify-center">
                  <Text className="!text-black !text-2xl !font-bold">
                    Boyalı veya Değişen Parça
                  </Text>
                </Col>
                <Col xs={24} lg={12} className="!flex items-center">
                  <StatusImage data={data} setData={setData} />
                </Col>
                <Col xs={24} lg={12}>
                  <StatusList data={data} setData={setData} />
                </Col>

                <>

                <Col span={24} className="!flex gap-4">
                {isValid && (
                  <>
                    
                    <MazakaButton
                      className="!p-4 !bg-black !text-white"
                      htmlType="button"
                      onClick={() => {
                        handleOnFinish("saved&continue");
                      }}
                    >
                      Kaydet ve Devam Et
                    </MazakaButton>
                  </>
                )}
                <MazakaButton
                  className="!p-4 !bg-[#FFC502] !text-black"
                  htmlType="submit"
                  processType={formActions.submitProcessType}
                >
                  Kaydet
                </MazakaButton>
              </Col>



                  
                </>
              </Row>
            </MazakaForm>
          </Col>
        </>
      )}
      </>
    }
    </>
  );
};

export default BodyReportIndex;
